import Component from '@ember/component';
import { hbs } from 'ember-cli-htmlbars';

/**
 * prism-blank is an internal utility component used to construct lightweight contextual components.
 *
 * For example in a template you can use prism-blank to attach a css class and
 * an element that is yielded to a child as a contextual component. Normally
 * this would require creating an entirely new component file for something
 * that is mainly presentational and context specific.
 * file
 *
 * @example
 * <div class="my-component">
 *  {{yield (hash
 *   title=(component "prism-blank" class="my-component__title" tagName="h3")
 *   footer=(component "prism-blank" class="my-component__footer")
 *  )}}
 *
 *
 */
export default Component.extend({
  layout: hbs`{{yield}}`
});